/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class SmallProgramApi {
    static getInstance() {
        if (!this.instance) this.instance = new SmallProgramApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取小程序列表
    async getSmallProgramList (param,num,size){
        let url = `/api/v1/page/authority/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取小程序名称列表
    async getSmallProgramQuery (param){
        let url = `/api/v1/page/authority/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 小程序权限设置
    async setAuth (param, app_id){
        let url = `/api/v1/page/authority/${app_id}/update/status`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 添加小程序
    async addSmallProgram(param, app_id){
        let url = `/api/v1/page/authority/add/${app_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 删除小程序
    async deleteSmallProgram(id){
        let url = `/api/v1/page/authority/delete/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 编辑小程序
    async editSmallProgram(param, app_id){
        let url = `/api/v1/page/authority/update/${app_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }
} 

export {
    SmallProgramApi
}